export const EtaStatusEndpoints = {
  GET_ALL_STATUSES: '/api/admin/logistics/etaStatus',
  ENABLE_STATUS: '/api/admin/logistics/etaStatus/:id/enable',
  SEND_ORDERS_DELAYED: '/api/admin/support/notifications/sendOrdersDelayed',
};
